module.exports = __webpack_public_path__ + "img/story_bg.23f4b42.png";